import React from 'react'
import Nav from './components/Nav'
import SingleCarOrHome from './components/SingleCarOrHome'

function App() {
  return (
    <>
      <Nav />
      <SingleCarOrHome />
    </>
  )
}

export default App
